import './_skeleton.scss'

const SkeletonCard = () => (
  <li className="skeleton-card">
    <div className="skeleton skeleton-img" />
    <div className="skeleton skeleton-title" />
    <div className="skeleton skeleton-subtitle" />
    <div className="skeleton skeleton-btn" />
  </li>
)

export default SkeletonCard

